import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { CorporateWorkorderDetailsComponent } from "../corporate-workorder-details/corporate-workorder-details.component";
import { CorporateService } from "../corporate.service";
import { MapGeocoder } from "@angular/google-maps";
declare var $: any;

@Component({
  selector: "app-corporate-work-orders",
  templateUrl: "./corporate-work-orders.component.html",
  styleUrls: ["./corporate-work-orders.component.css"],
})
export class CorporateWorkOrdersComponent implements OnInit {
  matDialogref: MatDialogRef<CorporateWorkorderDetailsComponent> | undefined;
  trips_track: boolean = true;
  tripType: any = "All";
  live_track: boolean = false;
  fetch_page: any = 1;
  currentPage: any = 1;
  startPage: any = 1;
  last_page: any = 1;
  document_array: any = [];
  // zoom = 20;
  otp: boolean = true;
  center: google.maps.LatLngLiteral = { lat: 0, lng: 0 };
  token: any;
  workOrderList: any = [];
  vehicleArray: any;
  latlngArray = [];
  startLoc: any = {};
  endLoc: any = {};
  curLoc: any = {};
  trackTimerObj: any;
  trackArray: any = [];
  Wo_track: boolean = false;
  @Input() item: string;
  workorderLoading: boolean = false;
  corporate_map: boolean = false;
  customerOtp: boolean = true;
  data: any;
  intervalId: any = null;
  isFirstInterval: boolean = true; // Add a flag to check if it's the first interval
  isFirstCall: boolean = true;
  searchWorkOrder: any = -1;
  searchButton: boolean = true;
  search_btn: boolean = false;
  toggleSearch: boolean = false;
  clear_Btn: boolean = false;
  isInputValid: boolean = false;
  previousValue: string = "";
  private lengthState: number = 0;
  @ViewChild("newItem", { static: false }) inputElement!: ElementRef;

  constructor(
    private router: Router,
    private matDialog: MatDialog,
    private corporateService: CorporateService,
    private snackBar: MatSnackBar,
    private services: CorporateService,
    private geocoder: MapGeocoder
  ) {}

  ngOnInit(): void {
    this.token = sessionStorage.getItem("corporate_token");
    this.getWorkOrder();
    if (this.token == null) {
      this.router.navigateByUrl("/");
    }
  }

  GoToDashboard() {
    this.router.navigateByUrl("/corporate/dashboard");
  }

  GoToBookATrips() {
    this.router.navigateByUrl("/corporate");
  }

  GoToTrips() {
    this.router.navigateByUrl("/corporate/trips");
  }

  GoTOWorkOrders() {
    location.reload();
    this.router.navigateByUrl("/corporate/work-order-list");
  }

  GoToLedger() {
    this.router.navigateByUrl("/corporate/ledger");
  }
  getTripsList(selectedTripType: any) {
    this.tripType = selectedTripType;
    this.fetch_page = 1;
    this.currentPage = 1;
    this.startPage = 1;
    this.document_array = [];
    this.getWorkOrder();
  }
  viewWorkOrders(item: any) {
    this.matDialogref = this.matDialog.open(
      CorporateWorkorderDetailsComponent,
      {
        width: "100%",
        maxHeight: "80vh",
        data: item,
        autoFocus: false,
      }
    );
  }
  liveTrack(item: any) {
    this.trips_track = false;
    this.workorderLoading = true;
    this.vehicleArray = undefined;
    this.data = "";

    let woDetails = this.workOrderList.find((it: any) => {
      return it._id == item;
    });
    
    this.corporate_map = true;
    this.workorderLoading = false;

    if (woDetails && woDetails.tripInfo) {
      this.vehicleArray = woDetails.tripInfo;
      // Auto-track the first trip if available
      if (this.vehicleArray.length > 0) {
        this.GetTruckId(this.vehicleArray[0]._id);
      }
    }
  }

  mapClick(item: any) {
    $("#myModal").modal("show");
  }

  closeModel() {
    $("#myModal").modal("hide");
  }

  onSelectionChange(event: any, tripId: any) {
    if (event.isUserInput) {
      this.workorderLoading = true; // Show loader when selection changes
      this.GetTruckId(tripId);
    }
  }

  // examples code //

  GetTruckId(item: any) {
    this.clearAllIntervals(); // Clear any previous intervals to prevent multiple instances
    this.trackArray = [];
    this.workorderLoading = true;

    const fetchTracking = () => {
      this.services.tracking(this.token, item).subscribe(
        (response: any) => {
          this.workorderLoading = false;
          const dataObj = response.body.data;
          this.trackArray = dataObj;
          
          const locArray = dataObj?.truckLocInfo || dataObj?.truckLocation;
          if (!locArray?.length) return;

          let locations = locArray.flat(Infinity);
          this.data = locations[locations.length - 1] || {};
          
          if ((!this.data.address || String(this.data.address).toLowerCase() === 'unknown') && this.data.latitude && this.data.longitude) {
            this.geocoder
              .geocode({
                location: {
                  lat: Number(this.data.latitude),
                  lng: Number(this.data.longitude),
                },
              })
              .subscribe(({ results }: any) => {
                if (results && results.length) {
                  this.data.address = results[0].formatted_address;
                }
              });
          }

          if (this.trackArray.customerCode == null || locations.length == 0) {
            this.customerOtp = false;
          } else {
            this.customerOtp = true;
          }

          const existingKeys = new Set();
          this.curLoc = locations
            .map((loc: any) => ({
              ...loc,
              lat: Number(loc.latitude || loc.lat),
              lng: Number(loc.longitude || loc.lng),
            }))
            .filter((loc: any) => {
              if (!loc.lat || !loc.lng || isNaN(loc.lat) || isNaN(loc.lng) || loc.lat === 0 || loc.lng === 0) {
                return false;
              }
              const key = `${loc.lat},${loc.lng}`;
              if (existingKeys.has(key)) {
                return false;
              }
              existingKeys.add(key);
              return true;
            });
        },
        (error) => {
          this.workorderLoading = false;
          this.trackArray = [];
          if (
            error.error.message === "jwt malformed" ||
            error.error.message === "jwt expired"
          ) {
            this.router.navigateByUrl("/");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
    };

    fetchTracking();
    this.intervalId = setInterval(fetchTracking, 10000);
  }

  vertices: google.maps.LatLngLiteral[] = this.latlngArray;

  getWorkOrder() {
    this.workorderLoading = true;
    this.corporateService
      .GetWorkOrder(this.token, this.tripType, this.startPage, this.searchWorkOrder)
      .subscribe(
        (response: any) => {
          if (response.status == 200) {
            this.workorderLoading = false;

            this.workOrderList = response.body?.data || [];
            if (response.body?.meta) {
              this.document_array.push(response.body.meta);
              this.last_page = response.body.meta.lastPage || 1;
            } else {
              this.last_page = 1;
            }
          }
        },

        (error) => {
          this.workorderLoading = false;
          this.workOrderList = [];
          if (error.status == 404) {
            this.last_page = 1;
            return;
          }
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("/");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("/");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  pagination(page_status: any) {
    let current = parseInt(this.currentPage) || 1;
    let newPage = current;

    if (page_status === "-1" || page_status === -1) {
      newPage = Math.max(1, current - 1);
    } else if (page_status === "1") {
      newPage = Math.min(this.last_page || 1, current + 1);
    } else if (page_status === "first") {
      newPage = 1;
    } else if (page_status === "last") {
      newPage = this.last_page || 1;
    } else {
      let parsed = parseInt(page_status);
      if (!isNaN(parsed)) {
        newPage = Math.max(1, Math.min(this.last_page || 1, parsed));
      }
    }

    if (newPage === current && (page_status === "-1" || page_status === "1")) {
      return;
    }

    this.currentPage = newPage;
    this.fetch_page = newPage;
    this.startPage = newPage;
    this.getWorkOrder();
  }
  onInputChange(input: HTMLInputElement) {
    const value = input.value;
    this.previousValue = value;

    const containsSpecialChars = /[^\w\d]/.test(value);
    if (containsSpecialChars) {
      input.value = value.replace(/[^\w\d]/g, "");
      this.previousValue = input.value;
      this.snackBar.open("Special characters are not allowed", "Fail", {
        duration: 5000,
      });
      return;
    }

    if (this.clear_Btn) {
      this.search_btn = true;
      this.clear_Btn = false;
    }

    this.isInputValid = value.trim().length >= 3;

    if (value.length === 0) {
      if (this.searchWorkOrder !== -1) {
        this.callApi();
      }
    }
  }

  private callApi() {
    this.searchWorkOrder = -1;
    this.fetch_page = 1;
    this.currentPage = 1;
    this.startPage = 1;
    this.getWorkOrder();
  }

  cancelWO() {
    this.toggleSearch = false;
    this.clear_Btn = false;
    this.searchButton = true;
    this.isInputValid = false;
    this.previousValue = "";
    this.searchWorkOrder = -1;
    this.fetch_page = 1;
    this.currentPage = 1;
    this.startPage = 1;
    this.getWorkOrder();
  }

  openSearch() {
    this.searchButton = false;
    this.clear_Btn = false;
    this.toggleSearch = true;
    this.search_btn = true;
    this.isInputValid = false;
    this.previousValue = "";
    if (this.toggleSearch) {
      setTimeout(() => this.inputElement?.nativeElement?.focus(), 0);
    }
  }

  search(value: any) {
    if (!value) {
      this.searchWorkOrder = -1;
      this.fetch_page = 1;
      this.currentPage = 1;
      this.startPage = 1;
      this.getWorkOrder();
      this.searchButton = true;
      this.toggleSearch = false;
      this.clear_Btn = false;
    } else {
      this.clear_Btn = true;
      this.search_btn = false;
      this.searchButton = false;
      this.fetch_page = 1;
      this.currentPage = 1;
      this.startPage = 1;
      this.searchWorkOrder = value;
      this.getWorkOrder();
    }
  }

  help() {
    this.router.navigateByUrl("/?target=support");
  }

  clearAllIntervals() {
    const interval_id = window.setInterval(function () {},
    Number.MAX_SAFE_INTEGER);
    for (let i = 1; i < interval_id; i++) {
      window.clearInterval(i);
    }
  }

  closeTracking() {
    this.getWorkOrder();
    this.trackArray = [];
    this.corporate_map = false;
    this.trips_track = true;
    this.curLoc = {};
    this.clearAllIntervals();
  }
  getTooltip(markerPosition: any): string {
    // Format tooltip text with line break
    return `${markerPosition.driverName}\n${markerPosition.vehicleNumber}`;
  }
}
